module.exports = __webpack_public_path__ + "img/logo-golstore.aa5ffced.png";